import { render, staticRenderFns } from "./Brandings.vue?vue&type=template&id=c796a834&scoped=true"
import script from "./Brandings.vue?vue&type=script&lang=js"
export * from "./Brandings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c796a834",
  null
  
)

export default component.exports